/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { AreaProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const areaProcessFetchAreaProcessLoading = (state, { boolean }) => ({
  ...state,
  processIsLoading: boolean
});

export const areaProcessFetchAreaProcessSuccess = (state, { process }) => ({
  ...state,
  process
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [AreaProcessTypes.AREA_PROCESS_FETCH_AREA_PROCESS_LOADING]: areaProcessFetchAreaProcessLoading,
  [AreaProcessTypes.AREA_PROCESS_FETCH_AREA_PROCESS_SUCCESS]: areaProcessFetchAreaProcessSuccess
});
